import { lazy } from 'react';
import authRoles from '../../../../auth/authRoles';

const ProjectKPIPage = lazy(() => import('./ProjectKPIPage'));

const ProjectKPIPageConfig = {
   settings: {
      layout: {
         config: {},
      },
   },
   auth: authRoles.user,
   routes: [
      {
         path: '/operator/masterdata/projectKPI',
         element: <ProjectKPIPage />,
      },
   ],
};

export default ProjectKPIPageConfig;
